import React, { Component, PropTypes } from 'react';
import RegisterForm from 'components/RegisterForm';
import ItemDetails from 'components/Store/ItemDetails';
import PaymentMethodChooser from 'components/Store/PaymentMethodChooser';
import KlarnaCheckoutForm from 'containers/Store/KlarnaCheckoutForm';
import KlarnaOnlineForm from 'containers/Store/KlarnaOnlineForm';
import StripeCheckoutForm from 'containers/Store/StripeCheckoutForm';
import CountdownTimer from 'components/CountdownTimer';
import Constants from 'Constants';
import PoweredBy from 'Cio/Assets/PoweredBy';
import { StoreOverviewActions } from 'actions';
import TaC from './TaC/StoreTaC';
import { translate as _l } from 'oxygen-i18n';
import { Units } from 'Css';
import { RaisedButton } from 'material-ui';

const css = oxygenCss({
  message: {
    textAlign: 'center'
  },
  root: {
    position: 'relative',
    color: '#333'
  },
  logo: {
    borderStyle: 'solid none none none',
    borderWidth: 1,
    borderColor: '#DDD',
    padding: Units.base * 2,
    lineHeight: '32px',
    color: '#09BEC3',
    fontSize: '24px',
    ' >SPAN': {
      verticalAlign: 'middle',
      marginLeft: '8px'
    }
  },
  container: {
    padding: Units.base * 4
  },
  buttonContainer: {
    paddingTop: Units.base * 4
  }
});

addTranslations({
  'en-US': {
    OK: 'OK',
    'Purchase complete': 'Purchase complete',
    'Purchase successfully completed. You will be redirected':
      'Purchase successfully completed. You will be redirected',
    'A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!':
      'A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!'
  },
  'sv-SE': {
    OK: 'OK',
    'Purchase complete': 'Köp genomfört',
    'Purchase successfully completed. You will be redirected':
      'Ditt köp gick igenom.',
    'A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!':
      'En presentkod har skickats till e-postadressen du angav. Ge den koden till mottagaren av presenten!'
  }
});

class Checkout extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  state = {
    tac: false
  };

  handleComplete = () => {
    const { isGift, onComplete } = this.props;
    const { router } = this.props;
    StoreOverviewActions.reset();
    router.push('/dashboard');
  };

  render() {
    const {
      loggedIn,
      owner,
      router,
      params,
      activeDiscountCount,
      setPaymentMethod,
      allowedPaymentProviders,
      paymentCompleted,
      isGift,
      method,
      countryCode,
      cart
    } = this.props;
    const { username: store } = params;
    const { tac } = this.state;
    let main;
    const [item] = cart;
    const hasKlarnaCheckout =
      (countryCode === 'SE' || countryCode === 'LT' || countryCode === 'UA')
      && item && item.currency === 'SEK'; //(allowedPaymentProviders || []).findIndex(provider => provider === Constants.paymentProviders.KLARNACHECKOUT) > -1;
    if (!loggedIn) {
      main = (
        <RegisterForm
          userName={store}
          userLocale={owner.locale}
          router={router}
          onTac={() => this.setState({ tac: true })}
        />
      );
    } else if (paymentCompleted && !isGift) {
      main = (
        <div className={css.message}>
          {_l`Purchase successfully completed. You will be redirected`}
          <br />
          <CountdownTimer
            seconds={9}
            color='#777'
            alpha={0.3}
            size={128}
            onComplete={this.handleComplete}
          />
        </div>
      );
    } else if (paymentCompleted && isGift) {
      main = (
        <div>
          <div className={css.container}>
            <h1>{_l`Purchase complete`}</h1>
            {_l`A gift code has been emailed to the address you provided. You can send the link in this email to the lucky person!`}
            <div className={css.buttonContainer}>
              <RaisedButton
                fullWidth
                secondary
                onTouchTap={this.handleComplete}
                label={_l`OK`}
              />
            </div>
          </div>
          <div className={css.details}>
            <h4 className={css.logo}>
              <PoweredBy color={'#09BEC3'} borderColor={'#09BEC3'} />
            </h4>
          </div>
        </div>
      );
    } else if (hasKlarnaCheckout) {
      main = (
        <KlarnaCheckoutForm open onRequestClose={this.handleRequestClose} />
      );
    } else {
      main = (
        <StripeCheckoutForm open onRequestClose={this.handleRequestClose} />
      );
    }

    return (
      <div>
        {main}
        {tac && (
          <TaC
            username={store}
            open={tac}
            onRequestClose={() => this.setState({ tac: false })}
          />
        )}
      </div>
    );
  }
}

export default Checkout;



// WEBPACK FOOTER //
// ./src/js/components/Checkout.js